module.exports = __webpack_public_path__ + "static/media/theme-4k-no-drop-targets.8e778124.svg";